import { Spin } from 'antd'
import React from 'react'
import styles from "./Spinner.module.scss"

const Spinner = () => {
  return (
    <div className={styles.spinner}><Spin /></div>
  )
}

export default Spinner